(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editable-home-07"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('melo-film-player')) {
    customElements.define('melo-film-player', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.preview = this.querySelector('.melo-film__preview');
        this.full = this.querySelector('.melo-film__full');
        this.watch = this.querySelector('.melo-film__watch');
        this.pauseButton = this.querySelector('.melo-film__pause');
        this.error = this.querySelector('.melo-film__error');
        this.fullMode = false;
        this.userPaused = false;
        this.inView = false;
        this.preview.muted = true;
        this.preview.hidden = false;
        this.full.hidden = true;
        this.watch.textContent = this.dataset.watchLabel;
        this.watch.setAttribute('aria-expanded', 'false');
        this.pauseButton.hidden = false;
        this.pauseButton.textContent = this.dataset.pauseLabel;
        const mobile = window.matchMedia('(max-width: 749px)').matches;
        this.source = (mobile && this.dataset.mobileSrc) || this.dataset.desktopSrc;
        this.watch.disabled = !this.source;
        this.pauseButton.disabled = !this.source;
        if (!this.source) this.error.hidden = false;

        const previewStart = () => {
          const start = Math.max(0, Number(this.dataset.previewStart) || 0);
          return Number.isFinite(this.preview.duration) ? Math.min(start, Math.max(0, this.preview.duration - 0.25)) : start;
        };
        this.preview.addEventListener('loadedmetadata', () => {
          this.preview.currentTime = previewStart();
        }, options);
        this.preview.addEventListener('timeupdate', () => {
          if (this.fullMode) return;
          if (!Number.isFinite(this.preview.duration)) return;
          const start = previewStart();
          const seconds = Number(this.dataset.previewSeconds) || 8;
          const end = Math.min(start + seconds, this.preview.duration);
          if (this.preview.currentTime < start || this.preview.currentTime >= end) this.preview.currentTime = start;
        }, options);
        this.watch.addEventListener('click', () => {
          this.error.hidden = true;
          if (this.fullMode) {
            this.fullMode = false;
            this.full.pause();
            this.full.hidden = true;
            this.preview.hidden = false;
            this.preview.currentTime = previewStart();
            this.userPaused = false;
            this.watch.textContent = this.dataset.watchLabel;
            this.watch.setAttribute('aria-expanded', 'false');
            this.pauseButton.hidden = false;
            this.pauseButton.textContent = this.dataset.pauseLabel;
            this.updatePreview();
            return;
          }
          this.fullMode = true;
          this.preview.pause();
          this.preview.hidden = true;
          this.full.hidden = false;
          this.full.controls = true;
          this.full.loop = false;
          this.full.muted = false;
          if (!this.full.getAttribute('src')) this.full.src = this.source;
          this.full.currentTime = 0;
          this.watch.textContent = this.dataset.returnLabel;
          this.watch.setAttribute('aria-expanded', 'true');
          this.pauseButton.hidden = true;
          this.full.play().catch(() => {});
        }, options);
        this.pauseButton.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.pauseButton.textContent = this.userPaused ? this.dataset.resumeLabel : this.dataset.pauseLabel;
          this.updatePreview();
        }, options);
        [this.preview, this.full].forEach(video => {
          video.addEventListener('error', () => {
            if (video === (this.fullMode ? this.full : this.preview)) this.error.hidden = false;
          }, options);
        });
        document.addEventListener('visibilitychange', () => this.updatePreview(), options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.inView = entries[0].isIntersecting;
            this.updatePreview();
          });
          this.observer.observe(this);
        } else {
          this.inView = true;
          this.updatePreview();
        }
      }

      updatePreview() {
        if (this.fullMode || this.userPaused || !this.inView || document.hidden || !this.source) {
          this.preview.pause();
          return;
        }
        if (!this.preview.getAttribute('src')) this.preview.src = this.source;
        this.preview.play().catch(() => {});
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        this.preview?.pause();
        this.full?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editable-home-12"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (event) {
  var swatch = event.target.closest('.swatches button');
  if (!swatch) return;

  var section = swatch.closest('[data-native-section="editable-home-12"]');
  if (!section) return;

  var color = swatch.getAttribute('aria-label');
  if (color !== 'Pearl White' && color !== 'Obsidian Black') return;

  section.querySelectorAll('[data-color-price]').forEach(function (price) {
    price.hidden = price.getAttribute('data-color-price') !==
      (color === 'Obsidian Black' ? 'black' : 'white');
  });
  tpUpdateHomeCheckout(section);
});

function tpUpdateHomeCheckout(section) {
  var link = section.querySelector('[data-home-checkout]');
  if (!link) return null;
  var selected = section.querySelector('.swatches button[aria-pressed="true"]');
  var black = selected && selected.getAttribute('aria-label') === 'Obsidian Black';
  var variantId = Number(link.getAttribute(black ? 'data-checkout-black' : 'data-checkout-white'));
  if (!Number.isSafeInteger(variantId) || variantId <= 0) return null;
  var cartPath = link.getAttribute('data-checkout-cart');
  if (!cartPath) return null;
  link.href = cartPath.replace(/\/$/, '') + '/' + variantId + ':1';
  return link;
}
function tpHomeCheckoutClick(event) {
  var link = event.target.closest('[data-home-checkout]');
  if (!link) return;
  var section = link.closest('[data-native-section="editable-home-12"]');
  if (!section) return;
  if (!tpUpdateHomeCheckout(section)) event.preventDefault();
}
document.addEventListener('click', tpHomeCheckoutClick, true);
document.addEventListener('auxclick', tpHomeCheckoutClick, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editable-product-01"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('melo-walkthrough-seek')) {
    customElements.define('melo-walkthrough-seek', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        const frame = this.previousElementSibling;
        const video = frame?.querySelector('video[data-inline-walkthrough]');
        const button = frame?.querySelector('.cinema-open');
        if (!video || !button) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const range = this.querySelector('input');
        const time = this.querySelector('.walkthrough-seek__time');
        let dragging = false;
        const formatTime = seconds => {
          const total = Math.max(0, Math.floor(seconds || 0));
          return Math.floor(total / 60) + ':' + String(total % 60).padStart(2, '0');
        };
        const sync = () => {
          const ready = Number.isFinite(video.duration) && video.duration > 0;
          range.disabled = !ready;
          if (!ready) return;
          range.max = String(video.duration);
          if (!dragging) range.value = String(Math.min(video.currentTime, video.duration));
          const elapsed = formatTime(dragging ? Number(range.value) : video.currentTime);
          const total = formatTime(video.duration);
          time.textContent = elapsed + ' / ' + total;
          range.setAttribute('aria-valuetext', elapsed + ' / ' + total);
        };
        button.addEventListener('click', () => {
          this.hidden = false;
          sync();
        }, options);
        ['loadedmetadata', 'durationchange', 'timeupdate', 'seeked', 'ended', 'emptied'].forEach(event => video.addEventListener(event, sync, options));
        range.addEventListener('pointerdown', () => { dragging = true; }, options);
        range.addEventListener('input', () => {
          if (range.disabled) return;
          video.currentTime = Math.min(video.duration, Math.max(0, Number(range.value)));
          sync();
        }, options);
        const finish = () => {
          dragging = false;
          sync();
        };
        range.addEventListener('change', finish, options);
        window.addEventListener('pointerup', finish, options);
        window.addEventListener('pointercancel', finish, options);
        if (!video.loop && !video.muted) this.hidden = false;
        sync();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-b"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('melod-moments-player')) {
  customElements.define('melod-moments-player', class extends HTMLElement {
    connectedCallback() {
      if (this.shadowRoot) return;
      const template = this.querySelector('template');
      if (!template) return;
      const shadow = this.attachShadow({mode: 'open'});
      shadow.append(template.content.cloneNode(true));
      this.video = shadow.querySelector('video');
      this.playButton = shadow.querySelector('.play');
      this.toggle = shadow.querySelector('.preview-toggle');
      this.back = shadow.querySelector('.back');
      this.status = shadow.querySelector('.status');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.mode = 'preview';
      this.previewPaused = this.reduced.matches;
      this.inView = false;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.playButton.addEventListener('click', () => this.startFull(), options);
      this.back.addEventListener('click', () => this.startPreview(true), options);
      this.toggle.addEventListener('click', () => {
        this.previewPaused = !this.previewPaused;
        this.syncPreview();
      }, options);
      this.video.addEventListener('ended', () => {
        if (this.mode === 'full') this.startPreview(true);
      }, options);
      this.video.addEventListener('error', () => {
        this.status.hidden = false;
        if (this.mode === 'full') this.video.controls = true;
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.video.pause();
        else this.syncPreview();
      }, options);
      this.reduced.addEventListener('change', () => {
        this.previewPaused = this.reduced.matches;
        this.syncPreview();
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting && entries[0].intersectionRatio >= .15;
        if (!this.inView) this.video.pause();
        else this.syncPreview();
      }, {threshold: [0, .15]});
      this.observer.observe(this);
      this.syncPreview();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.video?.pause();
    }
    setSource(url) {
      if (this.video.getAttribute('src') !== url) {
        this.video.src = url;
        this.video.load();
      }
    }
    syncPreview() {
      if (this.mode !== 'preview') return;
      this.toggle.setAttribute('aria-pressed', String(this.previewPaused));
      this.toggle.querySelector('.icon').textContent = '';
      if (!this.inView || document.hidden || this.previewPaused) {
        this.video.pause();
        return;
      }
      this.setSource(this.video.dataset.preview);
      this.video.muted = true;
      this.video.loop = true;
      const attempt = this.video.play();
      if (attempt) attempt.catch(() => {
        if (this.mode !== 'preview') return;
        this.previewPaused = true;
        this.syncPreview();
      });
    }
    startFull() {
      this.mode = 'full';
      this.video.pause();
      this.status.hidden = true;
      this.setSource(this.video.dataset.full);
      this.video.currentTime = 0;
      this.video.loop = false;
      this.video.muted = false;
      this.video.controls = true;
      this.video.classList.add('full');
      this.playButton.hidden = true;
      this.toggle.hidden = true;
      this.back.hidden = false;
      const page = this.closest('#home-b');
      page?.querySelectorAll('video').forEach(video => video.pause());
      page?.querySelectorAll('[data-chord][aria-pressed="true"], [data-sound][aria-pressed="true"]').forEach(button => {
        if (button.closest('section')?.querySelector('.is-playing')) button.click();
      });
      this.video.focus();
      const attempt = this.video.play();
      if (attempt) attempt.catch(() => {
        if (this.mode === 'full') this.status.hidden = false;
      });
    }
    startPreview(focus) {
      this.mode = 'preview';
      this.video.pause();
      this.video.controls = false;
      this.video.muted = true;
      this.video.loop = true;
      this.video.classList.remove('full');
      this.status.hidden = true;
      this.playButton.hidden = false;
      this.toggle.hidden = false;
      this.back.hidden = true;
      this.setSource(this.video.dataset.preview);
      this.syncPreview();
      if (focus) this.playButton.focus();
    }
  });
}


if (!customElements.get('melod-app-showcase')) {
  customElements.define('melod-app-showcase', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound) return;
      this.dataset.bound = 'true';
      const buttons = [...this.querySelectorAll('[data-app]')];
      const select = button => {
        const value = button.dataset.app;
        buttons.forEach(item => {
          const selected = item === button;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
          const panel = this.querySelector('#' + item.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });
        this.querySelectorAll('[data-app-image]').forEach(image => {
          image.hidden = image.dataset.appImage !== value;
        });
      };
      buttons.forEach(button => button.addEventListener('click', () => select(button)));
      this.querySelector('[role="tablist"]').addEventListener('keydown', event => {
        const index = buttons.indexOf(event.target.closest('[data-app]'));
        if (index < 0 || !['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'].includes(event.key)) return;
        event.preventDefault();
        event.stopPropagation();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (/Right|Down/.test(event.key) ? 1 : -1) + buttons.length) % buttons.length;
        buttons[next].focus();
        buttons[next].click();
      });
      select(buttons.find(button => button.getAttribute('aria-selected') === 'true') || buttons[0]);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-original-features"]) return;
  try {
    

if (!customElements.get('melod-moments-player')) {
  customElements.define('melod-moments-player', class extends HTMLElement {
    connectedCallback() {
      if (this.shadowRoot) return;
      const template = this.querySelector('template');
      if (!template) return;
      const shadow = this.attachShadow({mode: 'open'});
      shadow.append(template.content.cloneNode(true));
      this.video = shadow.querySelector('video');
      this.playButton = shadow.querySelector('.play');
      this.toggle = shadow.querySelector('.preview-toggle');
      this.back = shadow.querySelector('.back');
      this.status = shadow.querySelector('.status');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.mode = 'preview';
      this.previewPaused = this.reduced.matches;
      this.inView = false;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.playButton.addEventListener('click', () => this.startFull(), options);
      this.back.addEventListener('click', () => this.startPreview(true), options);
      this.toggle.addEventListener('click', () => {
        this.previewPaused = !this.previewPaused;
        this.syncPreview();
      }, options);
      this.video.addEventListener('ended', () => {
        if (this.mode === 'full') this.startPreview(true);
      }, options);
      this.video.addEventListener('error', () => {
        this.status.hidden = false;
        if (this.mode === 'full') this.video.controls = true;
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.video.pause();
        else this.syncPreview();
      }, options);
      this.reduced.addEventListener('change', () => {
        this.previewPaused = this.reduced.matches;
        this.syncPreview();
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting && entries[0].intersectionRatio >= .15;
        if (!this.inView) this.video.pause();
        else this.syncPreview();
      }, {threshold: [0, .15]});
      this.observer.observe(this);
      this.syncPreview();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.video?.pause();
    }
    setSource(url) {
      if (this.video.getAttribute('src') !== url) {
        this.video.src = url;
        this.video.load();
      }
    }
    syncPreview() {
      if (this.mode !== 'preview') return;
      this.toggle.setAttribute('aria-pressed', String(this.previewPaused));
      this.toggle.querySelector('.icon').textContent = '';
      if (!this.inView || document.hidden || this.previewPaused) {
        this.video.pause();
        return;
      }
      this.setSource(this.video.dataset.preview);
      this.video.muted = true;
      this.video.loop = true;
      const attempt = this.video.play();
      if (attempt) attempt.catch(() => {
        if (this.mode !== 'preview') return;
        this.previewPaused = true;
        this.syncPreview();
      });
    }
    startFull() {
      this.mode = 'full';
      this.video.pause();
      this.status.hidden = true;
      this.setSource(this.video.dataset.full);
      this.video.currentTime = 0;
      this.video.loop = false;
      this.video.muted = false;
      this.video.controls = true;
      this.video.classList.add('full');
      this.playButton.hidden = true;
      this.toggle.hidden = true;
      this.back.hidden = false;
      const page = this.closest('#home-b');
      page?.querySelectorAll('video').forEach(video => video.pause());
      page?.querySelectorAll('[data-chord][aria-pressed="true"], [data-sound][aria-pressed="true"]').forEach(button => {
        if (button.closest('section')?.querySelector('.is-playing')) button.click();
      });
      this.video.focus();
      const attempt = this.video.play();
      if (attempt) attempt.catch(() => {
        if (this.mode === 'full') this.status.hidden = false;
      });
    }
    startPreview(focus) {
      this.mode = 'preview';
      this.video.pause();
      this.video.controls = false;
      this.video.muted = true;
      this.video.loop = true;
      this.video.classList.remove('full');
      this.status.hidden = true;
      this.playButton.hidden = false;
      this.toggle.hidden = false;
      this.back.hidden = true;
      this.setSource(this.video.dataset.preview);
      this.syncPreview();
      if (focus) this.playButton.focus();
    }
  });
}


if (!customElements.get('melod-app-showcase')) {
  customElements.define('melod-app-showcase', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound) return;
      this.dataset.bound = 'true';
      const buttons = [...this.querySelectorAll('[data-app]')];
      const select = button => {
        const value = button.dataset.app;
        buttons.forEach(item => {
          const selected = item === button;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
          const panel = this.querySelector('#' + item.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });
        this.querySelectorAll('[data-app-image]').forEach(image => {
          image.hidden = image.dataset.appImage !== value;
        });
      };
      buttons.forEach(button => button.addEventListener('click', () => select(button)));
      this.querySelector('[role="tablist"]').addEventListener('keydown', event => {
        const index = buttons.indexOf(event.target.closest('[data-app]'));
        if (index < 0 || !['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'].includes(event.key)) return;
        event.preventDefault();
        event.stopPropagation();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (/Right|Down/.test(event.key) ? 1 : -1) + buttons.length) % buttons.length;
        buttons[next].focus();
        buttons[next].click();
      });
      select(buttons.find(button => button.getAttribute('aria-selected') === 'true') || buttons[0]);
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
